import { Credentials } from '../../domain/credentials/Credentials';
import { CredentialsDTO } from '../../domain/credentials/CredentialsDTO';
import { PlannerCredentialsMapper } from './PlannerCredentialsMapper';

export class CredentialsMapper {
  static toDomain(props: CredentialsDTO): Credentials {
    const { id, type, planner, meta } = props;

    return Credentials.create({
      id,
      type,
      planner: PlannerCredentialsMapper.toDomain(planner),
      meta,
    });
  }
}
